export const CANCEL_SURVEY_VIDEO_ID = ['electronicId', 'eidv']

export const CANCEL_SURVEY_MICROPAYMENT = ['tink', 'micropayment']

export const CANCEL_SURVEY_TERMS_AND_CONDITIONS = ['termsAndConditions']
